export default __webpack_public_path__ + "static/media/personalized-treatments.2b124701.png";